const YoutubeBreadCrumbSchema = (breads) => {
  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList'
  };
  schema.itemListElement = breads
    .filter((bread) => bread.title && bread.url)
    .map((bread, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: bread.title,
      item: `https://unacademy.com${bread.url}`
    }));

  return schema;
};

export default YoutubeBreadCrumbSchema;
